import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/* One dialog for "New role" and "Rename" — a name, and what it will and won't do. */
export function RoleNameDialog({ open, role, busy, onClose, onSave }) {
  const [name, setName] = useState("");
  useEffect(() => { if (open) setName(role?.name || ""); }, [open, role]);
  const making = !role;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="role-name-dialog" className="rounded-lg max-w-md">
        <DialogHeader>
          <DialogTitle>{making ? "New role" : `Rename “${role.name}”`}</DialogTitle>
          <DialogDescription>
            {making
              ? "It starts with every toggle OFF and nobody in it. Nobody gains anything until you switch toggles on and move someone in."
              : "Only the name the screens show changes. Everyone in it keeps exactly the access they have."}
          </DialogDescription>
        </DialogHeader>
        <Input data-testid="role-name-input" autoFocus value={name} maxLength={40} placeholder="e.g. Manager"
          onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && name.trim()) onSave(name); }} />
        <DialogFooter>
          <Button data-testid="role-name-cancel" variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="role-name-save" disabled={busy || name.trim().length < 2} onClick={() => onSave(name)}
            className="bg-[#E0781A] hover:bg-[#C76714] text-white">{making ? "Make the role" : "Rename"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
